export enum UserAccess {
  SUPER_USER = 'superusuario',
  ENERPRY = 'enerpry',
  CLI_ADMIN = 'cliadmin',
  CLI_CENTER = 'clicentro',
}
